import React from "react";
import Title from "../title";
import CharacteristicsItems from "../characteristic-items";

const MainCharacteristics = (props) => {
  return (
    <div>
      <Title {...props} />
      <div
        className="main-characterisctics"
        data-cy={(props && props.cyData) || ""}
      >
        <CharacteristicsItems {...props} />
      </div>
      <style jsx>{`.main-characterisctics {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
`}</style>
    </div>
  );
};

export default MainCharacteristics;
